// https://github.com/ljharb/proposal-global
var $export = require('./_export');

$export($export.S, 'System', {global: require('./_global')});


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/es7.system.global.js
 **/